import React, { FC, useMemo } from "react";

interface Props {
  settings: any;
  showPreview?: boolean;
  embeddedPreviewLink?: string;
}

export const Preview: FC<Props> = ({ settings, showPreview, embeddedPreviewLink }) => {

  // const embeddedPreviewLink = useMemo(() => {
  //   let settingsString = "";
  //   Object.entries(settings).forEach(([key, val]) => {
  //     const value = (val as string) || '';
  //     const valueString = value.includes("#") ? value.slice(1) : value;
  //     settingsString += `&${key}=${valueString}`;
  //   });
  //   return previewLink + settingsString;
  // }, [previewLink, settings]);

  return (
    <div className="min-w-[60%] border border-border-token bg-surface-2 min-h-[410px]">
      {showPreview && (
        <iframe
          width="100%"
          height={410}
          src={embeddedPreviewLink}
          title="embed preview page"
        />
      )}
    </div>
  );
};
